export const queryKeys = {
  topics: ["topics"] as const,
  departments: ["departments"] as const,
} as const;
